<template lang="pug">
div
  #preloader(v-if="favListAction")
    #loader
  template(v-if="!pageLoading")
    .globby.s2
      template(v-if="visibleItems.length > 0")
        template(v-if="game.game_code !== undefined" v-for="game in filteredList()")
          .gggl
            router-link(v-if="isLoggedIn" :to="`/launchGame?game=${game.game_code}&p=WIFY`" target="_blank")
              .iimg
                template(v-if="game.game_code!='WIFY_Lobby'" )
                  VLazyImage(:src="game.game_image" src-placeholder="/new/img/fallb/WINFINITY.png" @error="$helpers.handleImageError($event,'WINFINITY')")
                template(v-else)
                  VLazyImage(src="/new/img/thumb/winfinity.jpg" src-placeholder="/new/img/fallb/WINFINITY.png" @error="$helpers.handleImageError($event,'WINFINITY')")
            a(v-else href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
              .iimg
                template(v-if="game.game_code!='WIFY_Lobby'" )
                  VLazyImage(:src="game.game_image" src-placeholder="/new/img/fallb/WINFINITY.png" @error="$helpers.handleImageError($event,'WINFINITY')")
                template(v-else)
                  VLazyImage(src="/new/img/thumb/winfinity.jpg" src-placeholder="/new/img/fallb/WINFINITY.png" @error="$helpers.handleImageError($event,'WINFINITY')")
            .fav.aaa
              i.fa-heart.pointer(:class="checkFav(game.game_code)" @click="favAction('WIFY',game.game_code,game.game_name, 'LIVE',game.game_image)")
            .name {{game.game_name}}
    .load(v-if="visibleItems.length < listToDisplay.length" @click="loadMore")
      | Load more 
      span.loaded {{ visibleItems.length }} /
      | {{ listToDisplay.length }}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default{
  props: {
    gameType:{
      type: String,
      default: ""
    },
    pCode:{
      type: String,
      default: ""
    },
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      pageLoading:false,
      listToDisplay: [],
      visibleItems: [], // Items currently displayed
      perPage: 15, // Number of items per load
      currentPage: 1,
      offList:[],
      favListAction: false,
      gameOrder:[
        {id: "WIFY_Lobby"},
      ],
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    favList(){
      return this.$store.getters.getFavlist.filter((x)=>x.game_type === 'LIVE')
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "my":
          return "my"
        case "zh":
          return "zh-CN"
        default :
          return "en"
      }
    },
  },
  mounted(){
    this.getProviderGameOfflist()
    // if(this.pCode!=null) this.getGameList()
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "WIFY"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
              this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        this.getGameList()
      }
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
      var url = config.getOneapiList()
      this.$http.post(url, {
        "platform": "WIFY",
        "gametype": "LIVE"
      }).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              this.gameList = successResponse.data
              this.listToDisplay = this.gameList
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.game_code === obj2.game_id)
              )
              const reOrderList = this.gameOrder.map(x => x.id);
              const customSort = (item1, item2) => {
                const index1 = reOrderList.indexOf(item1.game_code);
                const index2 = reOrderList.indexOf(item2.game_code);
                if (index1 === -1 && index2 === -1) {
                  // If neither element is in order_array, maintain the original order.
                  return 0;
                } else if (index1 === -1) {
                  // If only arr1 is not in order_array, move it to the end.
                  return 1;
                } else if (index2 === -1) {
                  // If only arr2 is not in order_array, move it to the end.
                  return -1;
                }

                // Compare the indices in order_array.
                return index1 - index2;
              };
              this.listToDisplay.sort(customSort)
              this.visibleItems= this.listToDisplay.slice(0, this.perPage)
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    filteredList(){
      return this.visibleItems.filter((game) =>
        game.game_name.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
    favAction(provider,game,name,type,img){
      if (this.sessionToken) {
        if(this.favList.some(obj=> obj.game_code === game)){
          this.removeFav(provider, game)
        }else{
          this.addFav(provider,game,name,type,img)
        }
      }else{
        this.$router.push("/login").catch(err => {});
      }
    },
    addFav(provider,game,name,type,img){
      if (this.sessionToken) {
        this.favListAction = true
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let game_name = name
        let provider_code = provider
        let game_type = type
        let img_url = img
        this.$store
          .dispatch("user/addFav", { account_id, auth_token,game_code, game_name, provider_code, game_type, img_url })
          .then(response => {
            if (response.success == true) {
              // console.log(response)
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    removeFav(provider, game){
      if (this.sessionToken) {
        this.favListAction = true
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    checkFav(code){
      if(this.favList.some(obj=> obj.game_code === code)){
        return "fa-solid"
      }else{
        return "fa-regular"
      }
    },
    getFavlist(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              // console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    loadMore() {
      const start = this.currentPage * this.perPage;
      const newItems = this.listToDisplay.slice(start);

      this.visibleItems = [...this.visibleItems, ...newItems];
      this.currentPage++;
    },
  }
}

</script>